import { Flex, Typography } from "antd"

import styles from "./SubtitleSection.module.less"

const { Text, Title } = Typography

export function SubtitleSection({ title, isMobile, description, noMargin }) {
  if (isMobile) {
    return (
      <Flex
        justify="space-between"
        align="flex-start"
        className={noMargin ? styles.wrapperMobileNoMargin : styles.wrapperMobile}
      >
        <div>
          <Title level={3} className={styles.titleMobile}>
            {title}
          </Title>
          <DescriptionText isMobile noMargin={noMargin}>
            {description}
          </DescriptionText>
        </div>
      </Flex>
    )
  }

  return (
    <Flex vertical gap={4} className={noMargin ? styles.wrapperNoMargin : styles.wrapper}>
      <Text className={styles.title}>{title}</Text>
      <DescriptionText noMargin={noMargin}>{description}</DescriptionText>
    </Flex>
  )
}

function DescriptionText({ isMobile, noMargin, children }) {
  if (!children) return null

  return (
    <Text
      type="secondary"
      className={
        isMobile
          ? noMargin
            ? styles.descriptionMobileNoMargin
            : styles.descriptionMobile
          : styles.description
      }
    >
      {children}
    </Text>
  )
}
